import { useSettingsRoutesAccount } from './useSettingsRoutesAccount'
import { useSettingsRoutesGeneral } from './useSettingsRoutesGeneral'
import { useSettingsRoutesNotifications } from './useSettingsRoutesNotifications'

interface ISettingsRoute {
    path:
        | string
        | Array<{ path: string; roles: string[]; props?: any; exact?: boolean }>
    Component: JSX.Element | JSX.Element[] | any
    roles?: string[]
    exact?: boolean
}

export const useSettingsRoutes = (): ISettingsRoute[] => {
    const settingsRoutesGeneral = useSettingsRoutesGeneral().map(
        (route: ISettingsRoute) => ({
            path: route.path,
            Component: route.Component,
            roles: route.roles,
            exact: route.exact
        })
    )
    const settingsRoutesAccount = useSettingsRoutesAccount().map(
        (route: ISettingsRoute) => ({
            path: route.path,
            Component: route.Component,
            roles: route.roles,
            exact: route.exact
        })
    )
    const settingsRoutesNotifications = useSettingsRoutesNotifications().map(
        (route: ISettingsRoute) => ({
            path: route.path,
            Component: route.Component,
            roles: route.roles,
            exact: route.exact
        })
    )
    return [
        ...settingsRoutesGeneral,
        ...settingsRoutesAccount,
        ...settingsRoutesNotifications
    ]
}
